<template>
  <div>
    <!-- 订单列表 -->
    <div class="table-head table-row">
      <el-row :gutter="20">
        <el-col :span="5"><div>产品名称</div></el-col>
        <el-col :span="3"><div>投/被保人</div></el-col>
        <el-col :span="2"><div>保费（元）</div></el-col>
        <el-col :span="3"><div>比例 / 服务费（元）</div></el-col>
        <el-col :span="3"><div>手机号</div></el-col>
        <el-col :span="5"><div>订单险种状态 / 双录状态</div></el-col>
        <el-col :span="3"><div>操作</div></el-col>
      </el-row>
    </div>
    <div v-for="(item, index) in orderList" :key="index">
      <div class="table-info">
        <div class="left">
          <div>创建时间：{{ item.createTime | timeStatus}}</div>
          <div>订单号：{{ item.id }}</div>
          <div>保单号：{{ item.policyNo }}</div>
          <div class="time" v-if="item.tips">
            <img src="@/static/images/time_01.png">
            <span v-html="item.tips"></span>
          </div>
        </div>
        <div class="right" v-if="['1','2'].includes(item.mechanLevel)">出单团队：{{ item.mechanName }}</div>
        <div class="right" v-if="item.mechanLevel=='3'">出单员工：{{ item.mechanName }}</div>
      </div>
      <div class="card">
        <div class="table-row table-info1">
          <el-row :gutter="20">
            <el-col :span="5">
              <span>{{ item.productName }}</span>
            </el-col>

            <el-col :span="3">
              <div>{{item.policyerName}}<span v-if="item.insuranceName">/</span>{{item.insuranceName}}</div>
            </el-col>

            <el-col :span="2">
              <span>{{ item.fee?item.fee:'-' }}</span>
            </el-col>

            <el-col :span="3">
              <span>{{item.commissionRate?item.commissionRate:'-'}}<span>/</span>{{item.totalIncomes?item.totalIncomes:'-'}}</span>
            </el-col>

            <el-col :span="3">
              <span>{{ item.policyerMobile?item.policyerMobile:'-' }}</span>
            </el-col>

            <el-col :span="5">
              <span>{{ item | filterOrderStatus(all) }}/</span>
              <span>{{ all.DOUBLE_RECORD_STATUS[item.doubleRecordStatus] }}</span>
              <span v-if="item.isDoubleRecordBirth == 1">-生日件</span>              
            </el-col>

            <el-col :span="3">
              <div>
                <el-button @click="getDetail( item.id )" type="text">详情</el-button>
                <el-button 
                  @click="$tools.copyUrl(item.payUrl)"
                  type="text"
                  v-if="item.payUrl&&item.orderStatus!=5&&item.orderStatus!=6&&item.orderStatus!=8&&item.orderStatus!=2"
                >复制投保链接
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="empty" v-if="orderList.length==0">
      <p>
        <img src="@static/images/no_msg.png" style="width:290px"/>
      </p>
      <p><span>暂无数据</span></p>
    </div>
    </div>
</template>

<script>
import activityTip from "@/components/activityTip";
import tooltip from "@/components/tooltip";
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  props: {
    orderList: Array
  },
  components:{activityTip, tooltip},
  watch:{
    orderList(val) {
        console.log(val)
    }
  },
  filters: {
    filterOrderStatus(data, all) {
      const val = data.orderStatus
      if(!val){
        return '-'
      }
      const payStatus = data.payStatus==1?'已支付':'未支付'
      if (val == "1") {
        return '未支付';
      } else if (val == "2" || val == "9") {
        return "已支付";
      } else if (val == "3") {
        return "已退款";
      } else if (val == "5" || val == "6") {
        return "已关闭";
      } else if (val == "7") {
        return payStatus+"-人核中";
      } else if (val == "4") {
        return payStatus+"-核保失败";
      } else if (val == "8") {
        return payStatus+"-已撤单";
      } else if (val == "-9") {
        return "未支付-扣款失败";
      } else if (val == "-2"){
        return "承保失败"
      } else {
        return all.ORDER_STATUS[val]||'-'
      }
    },
  },
  data: () => ({
    all: {},
    reVisitList: [],
    reVisitLod: false,
  }),
  created() {
    this.$tools.getall((data) => {
      this.all = data;
    });
  },
  methods: {
    getRevisit(policyNo,index) {
      this.reVisitList = []
      this.reVisitLod = true
      let url = `/master/policyReceipt/queryListByPolicyNo/${policyNo}`
      this.$http({
        url: url,
        type: 'get',
      }).then((res) => {
          res.data = res.data.map((item) => {
              if(item.revisitTime){
                let itemArr = item.revisitTime.replace(/-/g, "/").split(":");
                item.revisitTime = itemArr[0] + ":" + itemArr[1];
                return item;
              }
              return item
          });
        // 回访时间，回访状态，回访备注都为空的数据筛选掉
       let newArr = res.data.filter(item=>{
          if (item.time) {
            item.time = item.time.replace(/-/g, '/').substr(0,16)
          }
          return item
        })
        if(newArr.length == 0){
          this.reVisitList=[]
          this.reVisitLod = false
        }else {
          this.reVisitList = newArr;
        this.reVisitLod = false

        }
        this.$nextTick(() => {
            if (this.$refs.popover) {
              this.$refs.popover[index].updatePopper();
            }
        })
        this.resetTip();
      }).catch(err=>{
        this.reVisitLod = false
      });
    },
    resetTip(){
      this.$nextTick(()=>{
        var t = document.documentElement.scrollTop;
        document.documentElement.scrollTop = t-0.1;
      })
    },
    // 跳转详情页
    getDetail(id) {
      this.$router.push({
        path: "/order_tbd_detail",
        query: {
          orderId: id
        },
      });
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./double_recording_list";
</style>
<style lang='scss'>
.gd-popper{
  padding:0;
  min-width: 97px;
  padding: 4px 10px;
}
.tooltips-tbd{
  .tips{
    width:200px;
    white-space:pre-wrap;
    text-align:left;
  }
}
</style>